import Request from './request';

async function imageUpload(file, thumbnail, folder_type) {
  var data = new FormData();
  data.append("image", file);
  data.append("folder_type", folder_type ? folder_type : "materials");
  if (thumbnail) {
    data.append("thumbnail", "1");
    data.append("cropped_width", "180");
    data.append("cropped_height", "180");
  }
  return Request('post', "api/file/post-image", data);
}

async function imagesUpload(files, thumbnail, folder_type) {
  if (Array.isArray(files)) {
    var data = new FormData();
    files.forEach(file => {
      data.append("images[]", file);
    })
    data.append("folder_type", folder_type ? folder_type : "materials");
    if (thumbnail) {
      data.append("thumbnail", "1");
      data.append("cropped_width", "180");
      data.append("cropped_height", "180");
    }
    return Request('post', "api/file/post-images", data);
  } else {
    return new Promise((resolve) => resolve());
  }
}

async function imageQacenterUpload(file, thumbnail) {
  var data = new FormData();
  data.append("image", file);
  data.append("folder_type", "images");
  if (thumbnail) {
    data.append("thumbnail", "1");
    data.append("cropped_width", "180");
    data.append("cropped_height", "180");
  }
  return Request('post', "api/file/post-image", data);
}

async function filesUpload(files, img_folder_type) {
  if (Array.isArray(files)) {
    var data = new FormData();
    files.forEach(file => {
      data.append("files[]", file);
    })
    data.append("img_folder_type", img_folder_type ? img_folder_type : "images");
    return Request('post', "api/file/post-files", data);
  } else {
    return new Promise((resolve) => resolve());
  }
}

async function shopFilesUpload(files, img_folder_type) {
  if (Array.isArray(files)) {
    var data = new FormData();
    files.forEach(file => {
      data.append("images[]", file);
    })
    data.append("folder_type", img_folder_type ? img_folder_type : "shop_images");
    return Request('post', "api/file/post-images-for-shop", data);
  } else {
    return new Promise((resolve) => resolve());
  }
}

export default {
  imageUpload,
  imagesUpload,
  filesUpload,
  imageQacenterUpload,
  shopFilesUpload,
};